import { UtilityBadgeType } from "@/src/types";
import UtilityTabBadge from "./UtilityTabBadge";

type Props = {
  badges: UtilityBadgeType[];
};

const UtilityBadges: React.FC<Props> = ({ badges }) => (
  <div className="laptop:gap-8 flex snap-x snap-mandatory gap-2 overflow-x-auto text-white">
    {badges.map(({ name, image, inactiveImage, active }) => {
      const assetUrl = active ? image.asset.url : inactiveImage.asset.url; // TODO: use createLocalAssetUrl after assets API is finished

      return (
        <UtilityTabBadge
          key={name}
          name={name}
          assetUrl={assetUrl}
          assetDescription={image.description}
        />
      );
    })}
  </div>
);

export default UtilityBadges;
